import * as api from '@/lib/api';

import type { LogRecord } from './types';

const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : 'no-window';
const isBot = /bot|crawler|spider|crawling/i.test(userAgent);

const writeCondition = () => {
    return window.navigator.onLine && !isBot;
};

interface CountableLogRecord extends LogRecord {
    count: number;
}

export class ServerStream {
    private currentThrottleTimeout?: ReturnType<typeof setTimeout>;
    private records: Record<string, CountableLogRecord> = {};
    public constructor() {
        this.records = {};

        this.start();

        // TODO: look at page visibility api here
        // https://github.com/GoogleChromeLabs/page-lifecycle
        window.addEventListener(
            'beforeunload',
            () => {
                if (this.currentThrottleTimeout) {
                    window.clearTimeout(this.currentThrottleTimeout);
                }
                const recs = this.recordsAsArray();
                if (recs.length) {
                    const messages = recs.map((rec): api.LogEntry => {
                        const { levelName, msg, time, ...rest } = rec;
                        return {
                            msg,
                            level: levelName,
                            time: time.toISOString(),
                            extra: rest,
                        };
                    });
                    api.log({ body: { messages } });
                    this.records = {};
                }
            },
            false
        );
    }

    start() {
        const throttleRequests = () => {
            // wait for any errors to accumulate
            this.currentThrottleTimeout = setTimeout(() => {
                const recs = this.recordsAsArray();
                if (recs.length) {
                    const messages = recs.map((rec): api.LogEntry => {
                        const { levelName, msg, time, ...rest } = rec;
                        return {
                            msg,
                            level: levelName,
                            time: time.toISOString(),
                            extra: rest,
                        };
                    });
                    api.log({ body: { messages } });
                    this.records = {};
                }
                throttleRequests();
            }, 3000);
        };

        throttleRequests();
    }

    stop() {
        setTimeout(() => {
            if (this.currentThrottleTimeout) {
                clearTimeout(this.currentThrottleTimeout);
                this.currentThrottleTimeout = undefined;
            }
        }, 1);
    }

    write(rec: CountableLogRecord) {
        rec.url = typeof window !== 'undefined' ? window.location.href : '';
        rec.userAgent = userAgent;
        if (this.currentThrottleTimeout && writeCondition()) {
            if (this.records[rec.msg]) {
                this.records[rec.msg].count++;
            } else {
                rec.count = 1;
                this.records[rec.msg] = rec;
            }
        }
    }

    recordsAsArray() {
        return Object.keys(this.records).map((errKey) => this.records[errKey]);
    }
}
